import styled from 'styled-components'

import { SvgFilter } from './SvgFilter'

export const FilterIcon = styled(SvgFilter)`
  margin-inline-end: 5px;
`
